import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Y si mi pareja no quiere participar?',
  answer: 'El manual incluye una sección para aplicar cambios unilaterales que fuerzan al vínculo a reaccionar positivamente.'
}, {
  question: '¿Es muy largo de leer?',
  answer: 'No. Está diseñado para gente estresada. Vas al grano en menos de 45 minutos.'
}, {
  question: '¿Sirve si no estamos casados?',
  answer: 'Sirve para cualquier relación de convivencia bajo presión económica.'
}];
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section ref={ref} className="w-full py-20 md:py-28 bg-[#FFFFFF]" data-id="element-61">
      <div className="max-w-3xl mx-auto px-6" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-12 text-center" data-id="element-64">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-65">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {
            opacity: 0,
            y: 20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-[#F0EDEB] rounded-xl overflow-hidden border border-black/5 shadow-md" data-id="element-66">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-black/5 transition-colors" data-id="element-67">
                  <span className="text-lg font-semibold text-[#2D2D2D] pr-4" data-id="element-68">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-69">
                    <ChevronDownIcon className="w-5 h-5 text-[#722F37] flex-shrink-0" data-id="element-70" />
                  </motion.div>
                </button>
                <motion.div initial={false} animate={{
              height: openIndex === index ? 'auto' : 0,
              opacity: openIndex === index ? 1 : 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-71">
                  <div className="px-6 pb-5 text-[#6B7280] leading-relaxed" data-id="element-72">
                    {faq.answer}
                  </div>
                </motion.div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}